import React from "react";
import styled from "styled-components"

const Styled={
    Wrap:styled.div`
        width:100%;
        height:80px;
    `,
}

const Not=()=>{
    return(
        <Styled.Wrap></Styled.Wrap>
    )
}
export default Not